import { render } from "./BoxLinkMd.vue?vue&type=template&id=ee51a2b8&scoped=true&lang=pug"
import script from "./BoxLinkMd.vue?vue&type=script&lang=js"
export * from "./BoxLinkMd.vue?vue&type=script&lang=js"

import "./BoxLinkMd.vue?vue&type=style&index=0&id=ee51a2b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee51a2b8"]])

export default __exports__